﻿import {SupplierSortByHookTypes} from "../../types/SupplierSortByHookTypes";
import {useEffect} from "react";
import _ from "underscore";
import {Supplier} from "../../types/Supplier";

const useSupplierSortByMonthlyRateLow = ({ searchSortBy, unsortedSuppliers, sortedSuppliersSetter }: SupplierSortByHookTypes) => {
  useEffect(() => {
    if (searchSortBy === 'monthly-rate-low' && unsortedSuppliers.length) {
      sortedSuppliersSetter(_.sortBy(unsortedSuppliers, (supplier: Supplier) => supplier?.pricePerMonth || Infinity));
    }
  }, [searchSortBy, sortedSuppliersSetter, unsortedSuppliers]);
}

export { useSupplierSortByMonthlyRateLow };
